import { DatoCmsSignUp } from 'lib/datoCms/queries/getAllSignUpLabels';
import { convertInImgType } from 'lib/datoCms/utils';

export const getContentUploadDocumentModal = (value: DatoCmsSignUp) => {
  return {
    title: value.modalUploadDocumentTitle,
    description: value.modalUploadDocumentText,
    image: convertInImgType(value.modalUploadDocumentImage),
  };
};
